// stores/patientStore.js
import { defineStore } from "pinia";

import {
  fetchPatientById,
  fetchPatientDXCodes,
  postNewCommentToDXRecord,
  editDXRecordComment,
  replyDXRecordComment,
  deleteDXRecordComment,
  setRecordRedundant,
  chartReviewed,
  fetchAssessmentDXHistory,
  deleteDXAssessmentDetail,
} from "@/api/patientApi";

import {
  getPatientAssmtList,
  getPatientAssmts,
  getPatientEncounters,
  getInPatientVisits,
  getPatientImmunizations,
  getPatientMedications,
  getPatientLabs,
  getPatientVitals,
  getPatientProcedures,
  getPatientAllergies,
  getPatientMeasures,
  getPatientCommunications,
} from "@/api/discreteDataApi";

import Vue from "vue";

import moment from "moment";
import { extendMoment } from "moment-range";
var moment1 = extendMoment(moment);

import { useFormatDate } from "@/use/formatDate.js";
import { createPinia } from "pinia";
import { useDashboardsStore } from "@/stores/dashboardsStore";
import { useUsersPatientsStore } from "@/stores/usersPatientStore";

// // console.log(" new MOMENT.js");
const currentDate = moment(Date.now()).format("MM-DD-YY");
// // console.log("currentDate : ", currentDate);

// // console.log("         PINIIA STORE      >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>          pStore : SET  messageComments");
// // console.log("             replace  state.xx  WITH   this.xx  ");

export const usePatientStore = defineStore("patientStore", {
  state: () => ({
    name: "HeyWood  J.  Bleume",
    count: 133,

    currentPatient: {
      patientConsole: [] || [],
      patientContainer: [] || [],
      patientConsoleTasks: {} || {},
    },
    currentPatientId: 0,
    currentPatientTasks: [],

    currentSelectedPatientTask: {},
    currentPatientTaskComments: [] || [],
    currentPatientAnnotationComments: [] || [],
    currentPatientMeasuresComments: [] || [],

    getCurrentPatientMeasures: {} || {},
    currentPatientMeasures: [] || [],
    currentSelectedPatientMeasure: {} || {},
    currentSelectedPatientMeasureRowId: "",

    measuresFields: [],
    measuresRecords: [],
    measuresLoadDate: "",
    measureYear: "",

    selectedICD10UserList: [],
    selectedICD10Value: "",

    // ! ASSESSMENTs and LIST
    pcAssessmentList: [],
    assessmentTypes: [],
    assessmentScheduledAppointments: [],
    assessmentClinicians: [],
    assessmentLocations: [],

    allowNewAssessment: false,
    allowViewSummary: false,
    allowCompleteAssessment: false,
    toggleSummaryText: false,

    currentOpenAssessmentId: 0,
    showAssmtInterViewForm: false,
    selectedAssessmentId: 0,
    isAssessmentComplete: false,

    currentPatientAssessmentDXHistory: [],
    showDxHistoryModal: false,

    showPatientAssessmentForm: false,

    assmtSummaryMedications: [],
    assmtSummaryVitals: [],
    dxCodeValidation: [],

    isLSBCollapsed: true,
    isLegendShown: false,
    lsbPaneSize: 50,

    allRecords: [] || [],

    allRecordsById: {}, // keyed off of personalDXCodeId
    assessmentIds: null, // list
    encounterIds: null, // list
    // activeIds: null, // list
    historicIds: null, // list

    comments: [], // list of comments keyed off of personalDXCodeNoteId (commentId)
    commentIdsByDXRecord: {},
    activities: {}, // list of activities keyed of of personalDXCodeTransactionId (activityId)
    activityIdsByDXRecord: {},
    opportunities: null,
    HCCTabIndex: 0,

    patientArray: [],
    patientIDStartList: [
      // 2714,
      // 40684,
      // 42185,
      // 41180,
      // 46605,
      // 45208,
      // 15225, 27734, 40295, 46190,
      // 44955,
      // 27734,
      9939,
      // 40295, 46190, 15225, 46605,
      // 46190,
      // 15225,
    ],

    // patientDXCodeResults: {
    //   dxCodeResultMeasures: { fields: [] || [], records: [] },
    //   dxCodeResultAnnotations: { fields: [] || [], records: [] },
    //   dxCodeResultMeds: {},
    //   dxCodeResultLabs: {},
    //   dxCodeResultLabsType2: {},
    //   dxCodeResultNuclears: { fields: [{ id: 1 }], records: [{ id: 991 }] },
    //   dxCodeResultProcedures: {},
    //   dxCodeResultRadiologies: {},
    //   dxCodeResultRelatedDXs: {},
    //   dxCodeResultTasks: {},
    //   dxCodeResultVitals: {},
    //   dxCodeResultVitalsType2: {},
    //   personId: null,
    // },
    // // todo deBIND HTML to ORIGIN OBJECT
    // patientDXCodeResultsLABS: [],
    // patientDXCodeResultsMEDS: [],
    // patientDXCodeResultsNUCLEAR: [],
    // patientDXCodeResultsRADIOLOGIES: [],
    // patientDXCodeResultsPROCEDURES: [],
    // patientDXCodeResultsRELEATEDdx: [],
    // patientDXCodeResultsTASKS: [],
    // patientDXCodeResultsVITALS: [],
    // patientDXCodeResultsANNON: [],

    // * NEW T selectedPersonalDXCodeId

    selectedPersonalDXCodeId: "",

    encounterRecords: [] || [],
    encounterRecordsQty: 0,
    activeRecordsQty: 0,
    historicRecordsQty: 0,

    // * STUB Master Arrays TO STORE
    pstrDXCodeRecords: [] || [],
    pstrDXCodeComments: [] || [],
    pstrDXCodeActivities: [] || [],

    // ? NEW PatCons []'s

    pcProblemList: {},

    pcAssessmentRecords: [],

    pcAssmts: {} || {},
    pcAllergies: {} || {},
    pcCommunications: {} || {},
    pcDocuments: {},
    pcEncounters: {},
    pcImmunizations: {} || {},
    pcInPatVisits: {} || {},
    pcLabs: {} || {},
    pcMeasures: {} || {},
    pcMedications: {} || {},
    pcProcedures: [],
    pcReminders: {} || {},
    pcVitals: {} || {},

    pcProblemListQty: 0,

    pcAssmtsQty: 0,
    pcAllergiesQty: 0,
    pcCommunicationsQty: 0,
    pcDocumentsQty: 0,
    pcEncountersQty: 0,
    pcImmunizationsQty: 0,
    pcInPatVisitsQty: 0,
    pcMeasuresQty: 0,
    pcMedicationsQty: 0,
    pcLabsQty: 0,
    pcProceduresQty: 0,
    pcRemindersQty: 0,
    pcVitalsQty: 0,

    currentPatientCommunications: [],
    currFilterdCOMMsQty: 0,
    currentPatientCommunicationsFields: [],
    currentPatientCommunicationsQty: 0,

    currentSelectedPatientCommunication: {},
    currentSelectedPatientCommunicationId: "",
    currentPatientCommunicationComments: [],
  }),
  // could also be defined as
  actions: {
    async getPatientById(patientId) {
      // // console.log(" Patient Store :  getPatientById  ", patientId);
      // // console.log("                     await  fetchPatientById(patientId) ");

      const result = await fetchPatientById(patientId);
      if (result.ok && result.payload) {
        // // console.log("                     setCurrentPatient ");
        // // console.log(result.payload);

        this.setCurrentPatient(result.payload);
        // commit('setCurrentPatient', result.payload)
        return result.payload;
      }
      return result.payload;
    },
    setCurrentPatient(payload) {
      // console.clear()

      // // console.log(" PAT STORE  : ");
      // // console.log("setCurrentPatient  INCOMING patient ");
      // // console.log(payload);

      // // console.log("       setting : STATE > currentPatient");
      this.currentPatient = payload;

      if (payload.personID !== null) {
        // // console.log("*                  running this.currentPatientId = payload.personID  <<<<");
        this.currentPatientId = payload.personID;

        // // console.log("                                  ************   RUN    this.getPatientConsoleData(payload.personID) !!!!!!!");
        this.getPatientConsoleData(payload.personID);
      }
    },
    async getPatientDXCodes(patientId, assessmentId = 0) {
      // // console.log("NEW           ==============       PATIENT STORE:   getPatientDXCodes     inc patientId: " + patientId);

      const result = await fetchPatientDXCodes(patientId, assessmentId);

      if (result.ok && result.payload) {
        this.setCurrentPatientDXCodes(result.payload);
        return result;
      }
      return result;
    },
    setCurrentPatientDXCodes(payload) {
      // // console.log(        "                   PATIENT STORE: setCurrentPatientDXCodes                       PATIENT STORE: setCurrentPatientDXCodes                                     PATIENT STORE: setCurrentPatientDXCodes payload",        payload      );
      // // console.log("     payload >>>>>>>>");
      // console.dir(payload);
      // // console.log("**** STORE     *********************************************************************************************************************************");

      // todo CONST   >>>       STUB PROPS
      const {
        personId,
        patientDXCodeRecords,
        patientDXCodeComments,
        patientDXCodeActivities,
        patientDXCodeAssessments,
        assessmentListRows,
        historicListRows,
        opportunities,
        comments,
        commentIdsByDXRecords,
        activities,
        activityIdsByDXRecords,
        allRecordsById,
        isAssessmentComplete,
        assessmentSummaryMedications,
        assessmentSummaryVitals,
      } = payload;
      // REM patientDXCodeResults,

      if (patientDXCodeRecords.length > 0) {
        this.allRecords = patientDXCodeRecords;
        this.allRecordsById = allRecordsById;
        // if (this.allRecordsById !== null) {
        //   this.pstrDXCodeRecords.forEach((element) => {
        //     this.allRecordsById[element.personalDXCodeId] = element;
        //   });
        // }
        // // console.log("this.allRecordsById");
        // // console.log(this.allRecordsById);

        // * Assessment stubs
        this.isAssessmentComplete = isAssessmentComplete;
        this.assmtSummaryMedications = assessmentSummaryMedications;
        this.assmtSummaryVitals = assessmentSummaryVitals;

        (this.pstrDXCodeRecords = patientDXCodeRecords), (this.currentPatientId = personId);
        // // console.log("this.currentPatientId ");
        // // console.log(this.currentPatientId);
      }

      // // console.log("this.allRecords");
      // // console.log(this.allRecords?.length);

      // // console.log(" OFF OFF OFF  Patient STORE:  ________patientDXCodeComments OFF OFF OFF ");

      if (patientDXCodeComments.length > 0) {
        if (this.commentIdsByDXRecord !== null) {
          // need to clear out previous entries in commentIdByDXRecord, comments
          this.comments = comments;
          this.commentIdsByDXRecord = commentIdsByDXRecords;

          // patientDXCodeComments.forEach((element) => {
          //   this.commentIdsByDXRecord[element.personalDXCodeId] = [];
          //   const noteId = element.personalDXCodeNoteId;
          //   const dxRecordId = element.personalDXCodeId;

          //   this.comments[noteId] = element;

          //   this.commentIdsByDXRecord[dxRecordId].push(noteId);
          // });

          // Getting object length
          var size = Object.keys(this.comments).length;
          // // console.log("                  _______________size"); // Prints:
          // // console.log(size); // Prints:

          // // console.log("this.commentIdsByDXRecord");
          // Getting object length
          var size = Object.keys(this.commentIdsByDXRecord).length;
          // // console.log(size); // Prints: 4
        }
      }

      // // console.log(" OFF OFF OFF  Patient STORE:  patientDXCodeActivities OFF OFF OFF ");
      // // console.log("this.comments");
      // Getting object length
      var size = Object.keys(this.comments).length;
      // // console.log(size); // Prints: 4

      if (patientDXCodeActivities.length > 0) {
        if (this.activityIdsByDXRecord !== null) {
          // need to clear out previous entries in activityIdByDXRecord
          this.activities = activities;
          this.activityIdsByDXRecord = activityIdsByDXRecords;

          // patientDXCodeActivities.forEach((element) => {
          //   this.activityIdsByDXRecord[element.personalDXCodeId] = [];
          //   const activityId = element.personalDXCodeTransactionId;
          //   const dxRecordId = element.personalDXCodeId;

          //   // Vue.set(this.activities, activityId, element);
          //   this.activities[activityId] = element;

          //   this.activityIdsByDXRecord[dxRecordId].push(activityId);
          // });
        }
      }

      // // console.log("activities  MAP        TO encounterIds ");

      // // console.log("this.activities");
      // Getting object length
      var size = Object.keys(this.activities).length;
      // // console.log(size); // Prints: 4
      var size1 = Object.keys(this.activityIdsByDXRecord).length;
      // // console.log(size1); // Prints: 4

      // // console.log(" DATA type   OBJ         ***   NOT   ARRAY *********            ");

      this.assessmentIds = assessmentListRows.map((assmt) => assmt.personalDXCodeId);
      // this.encounterIds = encounterWorklistRows.map((encounter) => encounter.personalDXCodeId);
      // // console.log("            this.assessmentIds");
      // // console.log(this.assessmentIds);
      // this.activeIds = activeProblemlistRows.map((active) => active.personalDXCodeId);
      this.historicIds = historicListRows.map((historic) => historic.personalDXCodeId);
      this.opportunities = opportunities;
    },

    setCurrentPatientTasks(payload) {
      // console.clear()
      // // console.log("**************");
      // // console.log("***STORE SETTER ***********");
      // // console.log("**************        setCurrentPatientTasks");
      // console.dir(payload);

      this.currentPatient.tasks = payload;

      this.currentPatientTasks = payload;

      // console.dir(this.currentPatientTasks);
      // console.dir(this.currentPatient.tasks)

      // // console.log('getC: Q: ',this.currentPatientTasks.length)
      // // console.log('currP.tasks: Q: ',this.currentPatient.tasks.length)

      // STORE NEW
      if (this.currentPatientTasks.length === 1) {
        // console.log("   ONLY one task  > setting setCurrentSelectedPatientTask");
        this.currentSelectedPatientTask = this.currentPatientTasks[0];
      }
    },
    setCurrentSelectedPatientTask(payload) {
      // console.log(
      // ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>s etCurrentSelectedPatientTask>>>>>>>>>>>>>>>             CURRENT SELECT PATIENT    TASK  SINGLE                   >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>"
      // );
      // console.log("***STORE SETTER ***********");
      // console.log(payload);

      // const patientId = payload.personId
      this.currentSelectedPatientTask = payload;
    },
    setCurrentPatientTasksComments(payload) {
      // console.clear()()
      // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
      // console.log("***STORE SETTER ***********");
      // console.log("payload");
      // console.dir(payload);
      // console.log("** STORE RESPONSE    ************");
      // console.log(" *** setCurrentPatientTasksComments *** NEW   SETTING  PATIENT STORE > TASK  Comments    setCurrentPatientTasksComments ");

      this.currentSelectedPatientTask.taskComments = payload;

      // * BIND NEW - this.currentPatient.tasks.taskComment

      // & NEW
      this.currentPatient.tasks.taskComments = payload;
      this.currentPatientTaskComments = payload;
    },

    async loadPatientsFromIDList(patientId) {
      const result = await fetchPatientById(patientId);
      if (result.ok && result.payload) {
        // console.log("         loadPatientsFromIDListloadPatientsFromIDList            setCurrentPatient ");
        // // console.log(result.payload);

        const resul1t = await result.payload;
        // console.log("                                                    resul1t");
        // console.log(resul1t);

        //            // console.log('this.patientArray')
        //            // console.log( this.patientArray)
        // console.dir(Object.values( this.patientArray).flat())

        // console.log("____________________________________________________________________________________________________________________________");
        // console.log("       SETTING  :  currentPatient");
        this.currentPatient = result.payload;
        this.currentPatientId = result.payload.personID;

        this.currentPatient.patientConsole = [];

        this.getPatientConsoleData(patientId);
        this.addPatientConsoleToCurrentPatient();

        // console.log("  ADD curr3entP to ARRAY          this.currentPatient");
        // console.log(this.currentPatient);
        // this.addPatientToArray( JSON.stringify( this.currentPatient ))

        this.patientArray.push(JSON.stringify(this.currentPatient));

        // console.log(" HOOK   add pStore.currP to upStore.addCuP    patientStore");
        const usersPatStore = useUsersPatientsStore();
        // console.log(" HOOK  UsersPat store >  addCurrentPatient  2 patientList   << ");
        // upSTore
        usersPatStore.addCurrentPatient(this.currentPatient);
      }
    },
    async getPatientAssmtListById(patientId) {
      // console.clear();
      // console.log("  GETTING PATIENT DATA by  ID  >>>>>>>>>>>>>>                PATIENT STORE:                   getPatientAssmtListById        patientId: " + patientId);

      // // console.log(" PATIENT CONSOLE DATA   is              ON              GO  GET STUFF   COME Back tomorrow  !!!!!!!!!!!!!!! ");
      if (patientId > 0) {
        // // console.log("   Getting Pat Console DATA by    patientId : ", patientId);

        // * TODO ASSESSMENT   TODO

        // & getPatientAssmtLIST
        // console.log("     getPatientAssmtList(patientId)");
        const resultList = await getPatientAssmtList(patientId);
        if (resultList.ok && resultList.payload) {
          // console.log(resultList.payload);

          // ^ allowNewAssessment = def TRUE
          // currentOpenAssessmentId = 0
          this.allowNewAssessment = resultList.payload.allowNewAssessment;
          this.currentOpenAssessmentId = resultList.payload.currentOpenAssessmentId;
          this.pcAssessmentList = resultList.payload.assessments;

          // * ADD NEW Biiinds
          this.assessmentTypes = resultList.payload.assessmentTypes;
          this.assessmentScheduledAppointments = resultList.payload.assessmentScheduledAppointments;
          this.assessmentClinicians = resultList.payload.assessmentClinicians;
          this.assessmentLocations = resultList.payload.assessmentLocations;

          this.checkCurrentOpenAssmtId();
        }

        return this.pcAssessmentList;
      }
    },
    async getPatientConsoleData(patientId) {
      // console.clear()
      // console.log("  GETTING PATIENT DATA by  ID  >>>>>>>>>>>>>>                PATIENT STORE:                   getPatientConsoleData        patientId: " + patientId);

      // console.log(" PATIENT CONSOLE DATA   is              ON              GO  GET STUFF   COME Back tomorrow  !!!!!!!!!!!!!!! ");
      if (patientId > 0) {
        // console.log("   Getting Pat Console DATA by    patientId : ", patientId);

        // * TODO ASSESSMENT   TODO

        // & getPatientAssmtLIST
        // console.log("     getPatientAssmts(patientId)");
        const result22 = await getPatientAssmtList(patientId);
        if (result22.ok && result22.payload) {
          // console.log(result22.payload);

          this.allowNewAssessment = result22.payload.allowNewAssessment;
          this.currentOpenAssessmentId = result22.payload.currentOpenAssessmentId;

          this.pcAssessmentList = result22.payload.assessments;

          // * ADD NEW Biiinds
          this.assessmentTypes = result22.payload.assessmentTypes;
          this.assessmentScheduledAppointments = result22.payload.assessmentScheduledAppointments;
          this.assessmentClinicians = result22.payload.assessmentClinicians;
          this.assessmentLocations = result22.payload.assessmentLocations;

          this.checkCurrentOpenAssmtId();
        }

        // & getPatientAssmts
        // // console.log("     getPatientAssmts(patientId)");
        // const result11 = await getPatientAssmts(patientId);
        // if (result11.ok && result11.payload) {
        //   this.pcAssmts = result11.payload;
        //   this.pcAssmtsQty = this.pcAssmts.records.length;
        // }

        // // console.log("                      WAITING on API call to be ADDED");

        // // & getPatientENCOUNTERS
        // // console.log("     getPatientEncounters(patientId)");
        // // console.log("________WAITIING ON  API LINK_________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________");
        // const resultEnc = await getPatientEncounters(patientId);
        // if (resultEnc.ok && resultEnc.payload) {
        //   this.pcEncounters = resultEnc.payload;

        // *        Encounters:  Count of open encounters ( StatusCode == 1
        // const testFi = this.pcEncounters?.filter((p) => p.StatusCode == 1);
        //       // console.log("testFi");
        //       // console.log(testFi);

        //   this.pcEncountersQty = this.pcEncounters.records.length;
        // }

        // & getInPatientVisits
        // // console.log(" GET    getInPatientVisits(patientId)");
        const result = await getInPatientVisits(patientId);
        if (result.ok && result.payload) {
          // // console.log('  RUN      this.setPCInPatientVisits(result.payload)')
          this.pcInPatVisits = result.payload;

          // * In-Patient:  Count of events where the DischargeDate within last 14 days

          const subFourteenDays = moment().subtract(14, "d").format("MM/DD/YYYY");
          // // console.log("subFourteenDays:  " + subFourteenDays);
          // // console.log(subFourteenDays);

          // var r1D = moment().add(7, 'days')
          // // 8- 14
          // var r1 = moment.rangeFromInterval('days', 6, subFourteenDays)
          // // console.log('	8 - 14 DAYS:  start: ', r1.start.format('YYYY-MM-DD'))
          // // console.log('							r1 end: ', r1.end.format('YYYY-MM-DD'))
          // this.next814Start = r1.start.format('YYYY-MM-DD')
          // this.next814 = r1.end.format('YYYY-MM-DD')
          //// // // console.log('							next814: ', this.next814)//
          // ! TO FIX filter
          // const testFi = this.pcInPatVisits?.filter((p) => useFormatDate(p.dischargeDate) >= "08/03/2024");
          const testFi1 = this.pcInPatVisits?.filter((p) => useFormatDate(p.dischargeDate) > useFormatDate(subFourteenDays));
          // const testFi2 = this.pcInPatVisits?.filter((p) => {
          //   // // console.log(p);
          //   // // console.log(  useFormatDate(p.dischargeDate) );
          //   // // console.log(subFourteenDays);
          //   // // console.log(useFormatDate(p.dischargeDate) >= subFourteenDays);
          //   // return useFormatDate(p.dischargeDate) >= subFourteenDays;

          //   if (useFormatDate(p.dischargeDate) >= subFourteenDays) {----------------------------559+8802.

          //     return p;
          //   }
          //   else {
          //     // console.log(' RETURN NULL')
          //     return null;
          //   }
          // });
          // // console.log("testFi");
          // // console.log(testFi);
          // // console.log("testFi1");
          // // console.log(testFi1);
          // // console.log("testFi2");
          // // console.log(testFi2);

          this.pcInPatVisitsQty = testFi1.length;
          // // console.log(" >>>>>>>>>>>>>>>>>>");
          // // console.log(this.pcInPatVisitsQty);
        }
        // & getPatientMedications
        // // // console.log('     getPatientMedications(patientId)')
        const result1 = await getPatientMedications(patientId);
        if (result1.ok && result1.payload) {
          this.pcMedications = result1.payload;

          // !        Medications:  Count of records where Status > 1
          const testMeds = this.pcMedications.records?.filter((p) => p.status > 1);
          // // console.log("testMeds");
          // // console.log(testMeds);

          this.pcMedicationsQty = testMeds?.length;
        }
        // & getPatientLABS
        // // console.log("   >>>>>>>>> OFF >>>>>  getPatientLabs(patientId)");
        const result2 = await getPatientLabs(patientId);
        if (result2.ok && result2.payload) {
          this.pcLabs = result2.payload;
          this.pcLabsQty = this.pcLabs.records.length;
        }

        // & getPatientVITALS
        // // console.log("     getPatientVitals(patientId)");
        const result3 = await getPatientVitals(patientId);
        if (result3.ok && result3.payload) {
          this.pcVitals = result3.payload;
          this.pcVitalsQty = this.pcVitals.records?.length;
        }
        // & getPatientImmunizations
        // // // console.log('     getPatientImmunizations(patientId)')
        const result4 = await getPatientImmunizations(patientId);
        if (result4.ok && result4.payload) {
          this.pcImmunizations = result4.payload;
          this.pcImmunizationsQty = this.pcImmunizations.records.length;
        }
        // & getPatientProcedures
        // // // console.log('     getPatientProcedures(patientId)')
        const result5 = await getPatientProcedures(patientId);
        if (result5.ok && result5.payload) {
          this.pcProcedures = result5.payload;

          // !        Procedures:  Count of records where completionStatus <> "Reviewed Final"

          const filterProc = this.pcProcedures.filter((record) => {
            // // console.log(record);
            if (record.completionStatus == "Reviewed Final") {
              return record;
            }
          });
          // // console.log("filterProc");
          // // console.log(filterProc);

          this.pcProceduresQty = filterProc?.length;
        }

        // & getPatientAllergies
        // // // console.log('     getPatientAllergies(patientId)')
        const result6 = await getPatientAllergies(patientId);
        if (result6.ok && result6.payload) {
          this.pcAllergies = result6.payload;
          this.pcAllergiesQty = this.pcAllergies.records.length;
        }

        // & getPatientMeasures
        // // // console.log('     getPatientMeasures(patientId)')
        const result7 = await getPatientMeasures(patientId);
        if (result7.ok && result7.payload) {
          this.pcMeasures = result7.payload;
          // ! Measures:  Count of records where complient == "N"
          const testMeas = this.pcMeasures.records?.filter((p) => p.complient == "Y");
          // // console.log("testMeas");
          // // console.log(testMeas);

          this.pcMeasuresQty = testMeas.length;
        }
        // &  getPatientCommunications
        // // // console.log('     getPatientCommunications(patientId)')
        const result8 = await getPatientCommunications(patientId);
        if (result8.ok && result8.payload) {
          this.pcCommunications = result8.payload;
          this.pcCommunicationsQty = this.pcCommunications.records.length;

          // TODO stubs FROM PatComm component onn CREATE

          // decompile fields and records
          // this.setCurrentSelectedPatientCommunication(this.communication.records[0])

          this.currentSelectedPatientCommunication = this.pcCommunications.records[0];
        }
        // // console.log(" PATIENT CONSOLE DATA   is    FILLED !!!!!!!!!  ");
        this.addPatientConsoleToCurrentPatient();

        return result3;
      }
    },

    async deletePatientAssessment(personalDXCodeId, assessmentId) {
      // console.log("   deleteDXAssessmentDetail    personalDXCodeId: " + personalDXCodeId);
      // console.log("   deleteDXAssessmentDetail    assessmentId: " + assessmentId);

      const result = await deleteDXAssessmentDetail(personalDXCodeId, assessmentId);

      if (result.ok) {
        //   this.setCurrentPatientAssessmentDXHistory(result.payload);
        return result;
      }
      return result;
    },

    async getPatientAssessmentDXHistory(personalDXCodeId, assessmentId) {
      // console.log("   getPatientAssessmentDXHistory    personalDXCodeId: " + personalDXCodeId);
      // console.log("   getPatientAssessmentDXHistory    assessmentId: " + assessmentId);

      const result = await fetchAssessmentDXHistory(personalDXCodeId, assessmentId);

      if (result.ok && result.payload) {
        this.setCurrentPatientAssessmentDXHistory(result.payload);
        return result;
      }
      return result;
    },
    setCurrentPatientAssessmentDXHistory(payload) {
      // console.clear()
      // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>        setCurrentPatientAssessmentDXHistory       >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
      // console.log("***STORE SETTER ***********");
      // console.log("payload");
      // console.dir(payload);
      // console.log("** STORE RESPONSE    ************");

      this.currentPatientAssessmentDXHistory = payload; // <<  ARRAY
      this.showDxHistoryModal = true;
    },
    clearCurrentPatientAssessmentDXHistory(state) {
      // console.clear();
      // console.log("***STORE clearCurrentPatientAssessmentDXHistory ***********");
      // console.log("   !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!                    CLEARING      currentPatientAssessmentDXHistory              ");

      return (this.currentPatientAssessmentDXHistory = []);
    },

    checkCurrentOpenAssmtId() {
      // // console.log("this.currentOpenAssessmentId: " + this.currentOpenAssessmentId);
      // console.log("  pat STORE  checkCurrentOpenAssmtId");
      // // console.log();
      // // console.log();
      if (this.currentOpenAssessmentId === 0) {
        this.allowViewSummary = false;
        this.allowCompleteAssessment = false;
      }
      if (this.currentOpenAssessmentId > 0) {
        this.allowViewSummary = true;
        this.allowCompleteAssessment = true;
      }

      // if (this.selectedAssessmentId > 0) {
      //   this.allowViewSummary = true;
      //   this.allowCompleteAssessment = true;
      // }
    },

    // ! TEST CALLS  fix Overloads
    // first argument is always vuex object
    async addCommentChangeStatus(commentStatus) {
      // console.log("        PAT Store  addCommentChangeStatus");
      const { commentText, validationStatus, personalDXCodeId, codingProblemRecord } = commentStatus;
      const response = await postNewCommentToDXRecord(commentText, validationStatus, personalDXCodeId, codingProblemRecord);
      return response;
    },

    async editComment(noteId, personalDXCodeId, editText) {
      const result = await editDXRecordComment(noteId.noteId, noteId.personalDXCodeId, noteId.editText);
      if (result.ok) {
        // commit('editDXRecordComment', { noteId, personalDXCodeId, editText })
        this.editDXRecordComment(noteId, personalDXCodeId, editText);
      }
      return result;
    },
    editDXRecordComment(payload) {
      // // console.log(" patStore       editDXRecordComment( payload ");
      // // console.log(payload);
      // // console.log();
      // // console.log();
      // // console.log();
      const comment = this.comments[payload.noteId];
      comment.commentText = payload.editText;
    },
    async replyComment(payload) {
      const result = await replyDXRecordComment(payload.parentNoteId, payload.personalDXCodeId, payload.replyText);
      if (result.ok) {
        // commit('replyDXRecordComment', {
        //   parentNoteId,
        //   personalDXCodeId,
        //   newComment: result.payload,
        // })

        // console.log("   replyComment   result CHECK  ");
        // console.log(result.payload);
        // console.log("");
        // console.log("");
        // console.log("");

        this.replyDXRecordComment(payload.personalDXCodeId, payload.parentNoteId, result.payload);
      }
      return result;
    },
    replyDXRecordComment(personalDXCodeId, parentNoteId, newComment) {
      // console.log(" patStore       replyDXRecordComment( payload ");
      // console.log(personalDXCodeId);
      // console.log(parentNoteId);
      // console.log(newComment);

      // Vue.set(state.comments, newComment.personalDXCodeNoteId, newComment)
      this.comments[newComment.personalDXCodeNoteId] = newComment;

      // figure out indentation depth and squeeze it in right after parent
      const parentComment = this.comments[parentNoteId];
      const parentIndex = this.commentIdsByDXRecord[personalDXCodeId].findIndex((id) => id === parentNoteId);
      newComment.depth = parentComment.depth + 1;
      this.commentIdsByDXRecord[personalDXCodeId].splice(parentIndex + 1, 0, newComment.personalDXCodeNoteId);
    },

    commitToggleRedundant(changedRecord) {
      // // console.log(' > > commitToggleRedundant')
      const { redundant, personalDXCodeId, personId, tabs } = changedRecord;
      // let activeIds = this.activeIds || [];
      let encounterIds = this.encounterIds || [];
      let historicIds = this.historicIds || [];

      // const activeIndex = activeIds.findIndex((id) => id === personalDXCodeId);
      const encounterIndex = encounterIds.findIndex((id) => id === personalDXCodeId);
      const historicIndex = historicIds.findIndex((id) => id === personalDXCodeId);
      if (redundant) {
        // activeIds.splice(activeIndex, 1);
        encounterIds.splice(encounterIndex, 1);
        historicIds.splice(historicIndex, 1);
      } else {
        if (tabs.indexOf(0) != -1) {
          encounterIds.push(personalDXCodeId);
        }
        if (tabs.indexOf(1) != -1) {
          // activeIds.push(personalDXCodeId);
        }
        // if (tabs.indexOf(2) != -1) {
        //   historicIds.push(personalDXCodeId)
        // }
      }
    },

    async deleteComment(noteId) {
      const result = await deleteDXRecordComment(noteId);
      if (result.ok) {
        // commit('deleteDXRecordComment', noteId)
        this.deleteDXRecordComment(noteId);
      }
      return result;
    },

    deleteDXRecordComment(noteId) {
      const comment = this.comments[noteId];
      const personalDXCodeId = comment.personalDXCodeId;
      // fix indent problem
      // who are my children...children's children and deindent by 1
      const removeIndex = this.commentIdsByDXRecord[personalDXCodeId].findIndex((id) => id === noteId);
      this.commentIdsByDXRecord[personalDXCodeId].splice(removeIndex, 1);
      // absolutely need to use Vue.delete here for reactivity. regular delete on object property won't work

      // Vue.delete(state.comments, noteId)
      delete this.comments[noteId];
    },

    async toggleRedundant(personalDXCodeId) {
      // console.clear()
      // console.log(" PAT STORE                                  toggle REDUNDANT  .       ACTION      .......................");

      const changedRecord = this.getDXRecord(personalDXCodeId);

      // console.log(" CURRENT VALU   changedRecord : ", changedRecord.redundant);
      // console.log("    SWITCH  changedRecord : ");

      // changedRecord.redundant = !changedRecord.redundant

      // console.log("changedRecord.redundant : ", changedRecord.redundant);

      // console.log("                 >>>>>>>>>>>>>>>>>>>>>>>>>>                       changedRecord : ", changedRecord);

      const result = await setRecordRedundant({
        personalDXCodeId,
        redundant: changedRecord.redundant,
        problemRecord: changedRecord.codingIssues.length > 0,
      });

      // console.log("        result : ", result);

      // ? REFACTOR without payload
      // if (result.ok && result.payload) {
      // if (result.ok ) {
      // // console.log('result.ok :                         commit(commitToggleRedundant, changedRecord)    ')

      // commit('commitToggleRedundant', changedRecord)
      this.commitToggleRedundant(changedRecord);
      // // console.log('result.ok :                         dispatch(fetchDashboards)')

      // console.log(" HOOK  to dashboardsStore ");
      const dashboardsStore = useDashboardsStore();
      await dashboardsStore.fetchDashboards();

      // dispatch('fetchDashboards')
      // return result
      // }
      return result;
    },

    async chartReviewed({ personId, comment }) {
      const result = await chartReviewed({ personId, comment });
      if (result.ok)
        // console.log(" >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ");
        // console.log(" running COMMIT  this.setCurrentPatient(  ");
        // console.log(" >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ");
        //  commit('setCurrentPatient', result.payload)
        this.setCurrentPatient(result.payload);
      return result;
    },

    addPatientConsoleToCurrentPatient() {
      this.currentPatient.patientConsole = [];
      this.currentPatient.patientConsole.push(this.pcProblemList);
      this.currentPatient.patientConsole.push(this.pcInPatVisits);
      this.currentPatient.patientConsole.push(this.pcMedications);
      this.currentPatient.patientConsole.push(this.pcLabs);
      this.currentPatient.patientConsole.push(this.pcVitals);
      this.currentPatient.patientConsole.push(this.pcImmunizations);
      this.currentPatient.patientConsole.push(this.pcProcedures);
      this.currentPatient.patientConsole.push(this.pcAllergies);
      this.currentPatient.patientConsole.push(this.pcMeasures);
      this.currentPatient.patientConsole.push(this.pcCommunications);
      this.currentPatient.patientConsole.push(this.pcDocuments);
      this.currentPatient.patientConsole.push(this.pcReminders);
    },

    // store NEW Mutation
    addPatientToArray(patient) {
      // console.log("                patient store  addPatientToArray         new patient STORE commit ");
      // console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
      // console.log("***STORE SETTER ***********");
      // console.log(patient);
      // // console.log(   'JSON.stringify(patient)')
      // // console.log(   JSON.stringify(patient))

      // console.dir(JSON.parse(patient))
      // console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
      // state.patientArray.push({    patient: patient,   })
      this.patientArray.push(patient);

      // // console.log('this.patientArray')
      // console.dir(this.patientArray)
      // return this.patientArray
    },

    setCurrentPatientTasksStatusComments(payload) {
      // // console.log('    >>>>>>>>>>>>>>>>>>>>>>>>>>>>   SETTING  PATIENT STORE > TASK  STATUS Comments    setCurrentPatientTasksStatusComments ')
      this.currentSelectedPatientTask.statusComments = payload;
      this.getCurrPatTaskStatusComments = payload;

      // console.log("  P store   Vue.set(state.currentSelectedPatientTask.statusComments,state.currentSelectedPatientTask.statusComments)");
      // Vue.set(state.currentSelectedPatientTask.statusComments, state.currentSelectedPatientTask.statusComments);
    },
    setCurrentPatientAnnotationComments(state, payload) {
      // //// console.clear()()
      // // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>      setCurrentPatientAnnotationComments   >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
      // // console.log('***STORE SETTER ***********')
      // // console.log('payload currentPatientAnnotationComments')
      // console.dir(payload)
      state.currentPatient.annotationComments = payload;
      // // // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> state.currentPatient.annotationComments >>>>>>>>>>>>>>>>>>>>>>>>')
      // // // console.log(state.currentPatient.annotationComments)

      state.currentPatientAnnotationComments = payload;
    },
    // &  NEW  Patient Measures on chart

    setCurrentPatientMeasures(payload) {
      // // console.clear()()
      // console.log("**************");
      // console.log("************** payload");
      // console.log(payload);
      // console.log("***STORE SETTER ***********   setCurrentPatientMeasures");
      // console.log("**************");
      this.getCurrentPatientMeasures = payload;
      // state.currentPatient.patientMeasures = payload
      this.currentPatientMeasures = this.getCurrentPatientMeasures.records;
      this.currentPatient.patientMeasures = this.currentPatientMeasures;

      // count
      this.patientMedicationsQty = this.currentPatientMeasures?.length;
    },

    // ? Patient Measures on chart
    setCurrentSelectedPatientMeasures(payload) {
      // // console.log('_________________     PATIENT  ________      STore :  setCurrentSelectedPatientMeasures     currentPatientMeasures')
      // // console.log('   STORE: payload : ')
      // console.dir(payload)
      // // console.log('***STORE SETTER ***********        currentSelectedPatientMeasure')

      this.currentSelectedPatientMeasure = payload;
      // state.currentPatient.patientMeasures.comments  = state.currentSelectedPatientMeasure.comments
      this.currentPatientMeasuresComments = state.currentSelectedPatientMeasure.comments;

      // // // console.log('***STORE SETTER ***********        currentPatientMeasures')
      // state.currentPatientMeasures = payload
      // // // console.log('***STORE SETTER ***********        state.currentPatient.patientMeasures.comments  =  state.currentPatientMeasures.comments'  )
      // state.currentPatient.patientMeasures =  state.currentPatientMeasures
      // state.currentPatient.patientMeasures.comments =  state.currentPatientMeasures.comments
      // // // console.log('           NEW         ***STORE SETTER state.currentPatient.patientMeasures.comments : ' + state.currentPatient.patientMeasures.comments )

      //  state.currentPatient.patientMeasures.comments  =  state.currentPatientMeasures.comments
      // // // console.log('***STORE SETTER ***********        state.currentPatientMeasuresComments = state.currentPatientMeasures.comments')
      // state.currentPatientMeasuresComments = state.currentPatientMeasures.comments
    },
    setCurrentPatientMeasuresComments(payload) {
      // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> state currentPatientMeasuresComments>>>>>>>>>>>>>>>>>>>>>>>>");
      this.currentPatientMeasuresComments = payload;
      // console.log("this.currentPatientMeasuresComments");
      // console.log(this.currentPatientMeasuresComments);
    },

    setCurrentPatientSelectedMeasureRowId(payload) {
      // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> state currentSelectedPatientMeasureRowId  >>>>>>>>>>>>>>>>>>>>>>>>");
      this.currentSelectedPatientMeasureRowId = payload;
      // console.log(this.currentSelectedPatientMeasureRowId);
    },

    // store NEW Mutation
    addPatientToDataArray(patient) {
      // console.log("                patient store  addPatientToArray         new patient STORE commit ");
      // console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
      // console.log("***STORE SETTER ***********");
      // console.dir(patient);
      // console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
      // state.patientArray.push({    patient: patient,   })
      this.patientArray.push(patient);

      // console.dir("this.patientArray");
      // console.dir(this.patientArray);
    },

    // & PATIENT   set CONSOLE ARRAYS
    setPatientConsoleData(state) {
      // console.log("_________________________Patient STore : this.currentPatientId  ", this.currentPatientId);
    },
    addPatientConsole(stuff) {
      // console.log("________________________addPatientConsole   stuff ");
      // console.log(stuff);

      const pConsoleStuffObj = { stuff, stuff };
      // console.log(pConsoleStuffObj);

      this.currentPatient.patientConsole.push(stuff);
    },

    setSelectedICD10Value(id) {
      // console.log("_________________________Patient STore :  setSelectedICD10Value");
      this.selectedICD10Value = id;
      // console.log(this.selectedICD10Value);

      // this.pushSelectedICD10UserList(id);
    },
    pushSelectedICD10UserList(value) {
      if (!this.selectedICD10UserList.includes(value)) {
        this.selectedICD10UserList.push(value);
      }
    },
    onSubmit(value) {
      const index = this.selectedICD10UserList.indexOf(tag);
      if (index > -1) {
        this.selectedICD10UserList.splice(index, 1);
      }
    },
    clearSelectedICD10UserList() {
      this.selectedICD10UserList = [];
    },
    clearSelectedICD10Value() {
      // console.log("_________________________Patient STore :  clearSelectedICD10Value");
      this.selectedICD10Value = "";
      // console.log(this.selectedICD10Value);
    },

    removeCurrentPatient() {
      // console.log("                                         PatientSTORE: removeCurrentPatient");
      this.currentPatient = null;
      this.currentPatientId = null;
      this.currentPatientTaskComments = null;
      this.currentPatientAnnotationComments = null;
      this.currentPatientMeasuresComments = null;
      this.currentPatientDocuments = null;
      this.currentPatientDirectories = null;
      this.currentPatientFiles = null;
      this.currentPatientCommunications = null;
      this.currentPatientCommunicationComments = null;
      this.currentPatientCommunicationsFields = null;
      this.currentPatientCommunicationsQty = null;

      this.getCurrentPatientTasks = null;
    },

    //  & COMMSd
    setCurrentSelectedPatientCommunication(payload) {
      // console.log("***STORE SETTER ***********   setCurrentSelectedPatientCommunication ");
      // console.log("***STORE SETTER         CURRENT COMMunication ");
      // console.log("payload : CURRENT SELECTED Comm");
      // console.dir(payload);

      if (payload !== undefined) {
        if (this.currentPatientCommunications !== null) {
          this.currentSelectedPatientCommunication = payload;

          // console.log("   new ON        pStore : SET  ID");
          // this.commit('setCurrentPatientCommunicationParentId', this.currentSelectedPatientCommunication.id)

          this.currentSelectedPatientCommunicationId = this.currentSelectedPatientCommunication.id;

          // console.log("  SETTING COMMs COMMENTS >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>          pStore : SET  messageComments");

          // console.log("     ..........sort  createdDate  currentPatientCommunicationComments    >>>>>>>>>>>>>> ");
          this.currentPatientCommunicationComments = this.currentSelectedPatientCommunication.messageComments.sort((a, b) => (a.createdDate < b.createdDate ? 1 : -1));
          // console.dir(this.currentPatientCommunicationComments);

          // // // console.log('.Formatting createdDate')
          this.currentPatientCommunicationComments.forEach((comment) => (comment.createdDate = moment(comment.createdDate).format("LLLL")));
          // console.log("                                         dONE");

          this.currentPatientCommunicationComments.forEach((comment) => {
            // console.log(" com createdDate : " + comment.createdDate);
          });
        } else {
          this.currentSelectedPatientCommunication = {};
          this.currentPatientCommunicationComments = [];
        }
      }
    },
    clearCurrentSelectedPatientCommunication(state) {
      return (this.currentSelectedPatientCommunication = {});
    },
    setCurrentPatientCommunicationParentId(payload) {
      // // //// console.clear()()
      // console.log("              ***STORE SETTER *********** currentSelectedPatient    CommunicationId");
      // console.log("payload");
      // console.dir(payload);
      this.currentSelectedPatientCommunicationId = payload;
    },
    setCurrentPatientCommunicationComments(payload) {
      // console.clear();
      // // // console.log('          33    ***STORE SETTER *********** setCurrentPatientCommunication  omments')
      // console.log("payload : COMMENTS Array");
      // console.dir(payload);

      // // // console.log('     ..........sort  createdDate  currentPatientCommunicationComments    >>>>>>>>>>>>>> ')
      this.currentPatientCommunicationComments = payload.sort((a, b) => (a.createdDate < b.createdDate ? 1 : -1));
      // // console.dir(this.currentPatientCommunicationComments)

      // // // console.log('.Formatting createdDate')
      this.currentPatientCommunicationComments.forEach((comment) => (comment.createdDate = moment(comment.createdDate).format("LLLL")));
      // // console.log('                                         dONE')

      this.currentPatientCommunicationComments.forEach((comment) => {
        // // // console.log(' com createdDate : ' + comment.createdDate)
      });

      //  this.currentPatientCommunicationComments = payload.forEach((comment) => {
      //      // // console.log(moment(comment.createdDate).format('MMMM Do YYYY, h:mm:ss a'))
      //   })

      //  this.currentPatientCommunicationComments.forEach((commentA,commentB) => commentA.currentDate > commentB.currentDate)

      // this.currentPatientCommunicationComments.forEach(
      //     (comment) => {
      //       return moment(comment.createdDate).format('MMMM Do YYYY, h:mm:ss a')
      //     }
      //   )
      // return this.currentPatientCommunicationComments
      // .map((person) => {
      //   person.tasks = person.tasks.filter((task) => task.status === filter)
      //   return person
      // })
      // .filter((person) => person.tasks.length !== 0)

      // // console.dir(this.currentPatientCommunicationComments)
    },
    setCurrentPatientCommunications(state, payload) {
      // console.log("***STORE SETTER ***********  setCurrentPatientCommunications");
      // console.log("payload : COMMUNICATIONS");
      // console.dir(payload);

      this.currentPatientCommunications = payload;
      this.currentPatient.communications = payload;
      this.currentPatientCommunicationsQty = this.currentPatientCommunications.length;

      // // // console.log('getC: Q: ',this.currentPatientCommunications.length)
      // // // console.log('currP.communications: Q: ',this.currentPatient.communications.length)

      // STORE NEW
      if (this.currentPatient.communications.length === 1) {
        // // // // // console.log('   ONLY one task  > setting setCurrentSelectedPatientTask')
        // // // // // console.log('   		this.currentSelectedPatientTask = this.currentPatient.tasks[0]')
        // this.currentSelectedPatientCommunication = this.currentPatient.communications[0]
        // // // console.log('   Ocommunications.length === 0) > setting currentSelectedPatientCommunication   currentPatientCommunicationComments')
        // // // console.log('   		= []')
      } else if (this.currentPatient.communications.length === 0) {
        // // // console.log('     PAT STORE  COMMS is 0   CLEAR  currentSelectedPatientCommunication currentPatientCommunicationComments')
        this.currentSelectedPatientCommunication = null;
        this.currentPatientCommunicationComments = [];
      }
    },
    setCurrentPatientCommunicationFields(state, payload) {
      // // // console.log('***STORE SETTER ***********  setCurrentPatientCommunicationFields  FIELDS')
      // // // console.log('payload : FIELDS')
      // // console.dir(payload)

      this.currentPatient.commFields = payload;
      this.currentPatientCommunicationsFields = payload;
    },
    setCommunicationFilters(state, commsFilters) {
      if (commsFilters.patientHasCommunications != null) {
        this.communicationFilters.patientHasCommunications = commsFilters.patientHasCommunications;
        this.currentPatient.patientHasCommunications = commsFilters.patientHasCommunications;
      }
      // if (usersFilters.taskTypes != null) {
      //   this.usersFilters.taskTypes = usersFilters.taskTypes
      // }
      // if (usersFilters.taskPriority != null) {
      //   this.usersFilters.taskPriority = usersFilters.taskPriority
      // }
      // if (usersFilters.patientStatus != null) {
      //   this.usersFilters.patientStatus = usersFilters.patientStatus
      // }
      // if (usersFilters.dateRanges != null) {
      //   this.usersFilters.dateRanges = usersFilters.dateRanges
      // }
      // if (usersFilters.selectedDateRange != null) {
      //   this.usersFilters.selectedDateRange.start = usersFilters.selectedDateRange.start
      //   this.usersFilters.selectedDateRange.end = usersFilters.selectedDateRange.end
      // }
    },
    setPatientHasCommunications(state, payload) {
      // // // console.log('***STORE SETTER ***********  setPatientHasCommunications  payload')
      // // // console.log('payload : payload')
      // // console.dir(payload)

      this.currentPatient.patientHasCommunications = payload;
      this.communicationFilters.patientHasCommunications = payload;
      this.patientHasCommunications = this.communicationFilters.patientHasCommunications;

      // patientHasReminders: false,
      // patientHasTasks: false,
      // patientHasInternal: false,
    },
    setPatientHasReminders(state, payload) {
      // // // console.log('***STORE SETTER ***********  setPatientHasReminders  payload')
      // // // console.log('payload : payload')
      // // console.dir(payload)
      this.currentPatient.hasReminders = payload;
      this.communicationFilters.patientHasReminders = this.currentPatient.hasReminders;
      this.patientHasReminders = this.communicationFilters.patientHasReminders;
    },
    setPatientHasTasks(state, payload) {
      // // // console.log('***STORE SETTER ***********  setPatientHasTasks  payload')
      // // // console.log('payload : payload')
      // // console.dir(payload)
      this.currentPatient.patientHasTasks = payload;
      this.communicationFilters.patientHasTasks = this.currentPatient.patientHasTasks;
      this.patientHasTasks = this.communicationFilters.patientHasTasks;
    },
    setPatientHasInternalComms(state, payload) {
      // // // console.log('***STORE SETTER ***********  setPatientHasTasks  payload')
      // // // console.log('payload : payload')
      // // console.dir(payload)
      this.currentPatient.patientHasInternal = payload;
      this.communicationFilters.patientHasInternal = this.currentPatient.patientHasInternal;
      this.patientHasInternal = this.communicationFilters.patientHasInternal;
    },

    doAlertFromStore() {
      // console.log("       doAlertFromStore");
      alert(" This is from PATIENT store");
    },
    doAlertFromStorepay(msg) {
      // console.log("doAlertFromStore");

      // console.log("payload");
      // console.log(msg);
      alert(" This is from PATIENT store   WITH PAYLOAD ");
    },

    setPersonalDXCodeId(DXCodeId) {
      // console.log("                                     *** STORE SET   setPersonalDXCodeId " + JSON.stringify(DXCodeId));

      // console.log("DXCodeId");
      // console.log(DXCodeId);
      // console.log();
      this.selectedPersonalDXCodeId = DXCodeId;
    },
    toggleAssmtInterviewForm(value) {
      this.showAssmtInterViewForm = value;
      // console.log(" >>>>>>>>>>>>>>>>>>>>>>>>> patStore    showAssmtInterViewForm   ", this.showAssmtInterViewForm);
    },
    toggleLSB() {
      // console.clear();
      this.isLSBCollapsed = !this.isLSBCollapsed;

      // & if  LSB = T   Legend T
      if (this.isLSBCollapsed) {
        this.isLegendShown = "true";
      }

      this.lsbPaneSize = this.isLSBCollapsed ? 50 : 200;

      // console.log(" >>>>>>>>>>>>>>>>>>>>>>>>> patStore    isLSBCollaisLegendShown   ", this.isLegendShown);
      // if ((this.isLSBCollapsed) && (this.isLegendShown)) {
      // this.isLegendShown = "true";
      // }

      // console.log(" END <<  isLegendShown   ", this.isLegendShown);
    },
    checkForOpenLegend() {
      // console.log(" checkForOpenLegend   ");
      // console.log(this.isLSBCollapsed);
      // console.log(this.isLegendShown);
    },
  },
  getters: {
    // * ?  GETTER not need  if STATE IS NOT MODIFIED ???
    // user: (state) => this._user,
    // canUseTasks: state => this.currentSecurityGroup == this.ruralFamilyMedicineGroup,
    // todo METHODS
    //  allRecords: state => augmentAllRecords(this.allRecords),
    // encounterRecords: state => groupRecords(this.allRecords, this.encounterIds),
    assessmentRecords: (state) => state.allRecords.filter((record) => state.assessmentIds.includes(record.personalDXCodeId)),
    // encounterRecords: (state) => state.allRecords.filter((record) => state.encounterIds.includes(record.personalDXCodeId)),
    // activeRecords: (state) => state.allRecords.filter((record) => state.activeIds.includes(record.personalDXCodeId)),
    historicRecords: (state) => state.allRecords.filter((record) => state.historicIds.includes(record.personalDXCodeId)),

    // todo METHODS
    // * ORG
    // allRecords: state => augmentAllRecords(this.allRecords),
    // encounterRecords: state => groupRecords(this.allRecords, this.encounterIds),
    // activeRecords: state => groupRecords(this.allRecords, this.activeIds),
    // historicRecords: state => groupRecords(this.allRecords, this.historicIds),

    filterdCommunications: (state) => (filter) => {
      // console.clear()()
      // console.log(" PatSTORE : get filteredPatientCommunications");
      // console.log(filter.type);
      // console.log(this.currentPatientCommunications.filter((com) => com.workType === filter.type).length);

      if (filter.type === "") {
        this.currFilterdCOMMsQty = this.currentPatientCommunications.length;
        // // console.log('currFilterdCOMMsQty: ' + this.currFilterdCOMMsQty )

        return this.currentPatientCommunications;
      }
      this.currFilterdCOMMsQty = this.currentPatientCommunications.filter((com) => com.workType === filter.type).length;
      // // console.log('currFilterdCOMMsQty: ' + this.currFilterdCOMMsQty )

      return this.currentPatientCommunications.filter((com) => com.workType === filter.type);
    },

    // & new
    commentsForRecord: (state) => (personalDXCodeId) => {
      const noteIds = state.commentIdsByDXRecord[personalDXCodeId];
      if (!noteIds) return [];
      return noteIds.map((id) => state.comments[id]);
    },
    activitiesForRecord: (state) => (personalDXCodeId) => {
      const ids = state.activityIdsByDXRecord[personalDXCodeId];
      if (!ids) return [];
      return ids.map((id) => state.activities[id]);
    },
    getDXRecord: (state) => (personalDXCodeId) => state.allRecordsById[personalDXCodeId],
    getCommentById: (state) => (commentId) => state.comments[commentId],
  },
});
